import type { ChainModifiers, Entry, EntryFieldTypes, EntrySkeletonType, LocaleCode } from 'contentful'
import type { TypeComponentCtaLinkSkeleton } from './TypeComponentCtaLink'
import type { TypeComponentLinkSkeleton } from './TypeComponentLink'
import type { TypeResourceImageSkeleton } from './TypeResourceImage'

export interface TypeComponentQuoteFields {
  body?: EntryFieldTypes.RichText
  attribution?: EntryFieldTypes.Symbol
  image?: EntryFieldTypes.AssetLink
  quoteImage?: EntryFieldTypes.EntryLink<TypeResourceImageSkeleton>
  backgroundColor?: EntryFieldTypes.Symbol<'Indigo Blue' | 'Light Gray' | 'Primary Blue' | 'White'>
  link?: EntryFieldTypes.EntryLink<TypeComponentLinkSkeleton>
  borderColor?: EntryFieldTypes.Symbol<'Gold' | 'Melon' | 'Teal' | 'Violet'>
  actions?: EntryFieldTypes.Array<EntryFieldTypes.EntryLink<TypeComponentCtaLinkSkeleton>>
  attributorImage?: EntryFieldTypes.EntryLink<TypeResourceImageSkeleton>
  attributorTitle?: EntryFieldTypes.Symbol
  attributionPosition?: EntryFieldTypes.Boolean
}

export type TypeComponentQuoteSkeleton = EntrySkeletonType<TypeComponentQuoteFields, 'componentQuote'>
export type TypeComponentQuote<Modifiers extends ChainModifiers, Locales extends LocaleCode = LocaleCode> = Entry<
  TypeComponentQuoteSkeleton,
  Modifiers,
  Locales
>

export function isTypeComponentQuote<Modifiers extends ChainModifiers, Locales extends LocaleCode>(
  entry?: Entry<EntrySkeletonType, Modifiers, Locales> | undefined
): entry is TypeComponentQuote<Modifiers, Locales> {
  return entry?.sys?.contentType?.sys?.id === 'componentQuote'
}
